module.exports = __webpack_public_path__ + "svg_80x80/azure.493c96.svg";